import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { Picture, PictureService } from '@app/_components/picture';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-property-image',
    templateUrl: './property-image.component.html',
    styleUrls: ['./property-image.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyImageComponent implements OnInit {
    isLoader = false;

	constructor(
		private primengConfig: PrimeNGConfig,
		private pictureService: PictureService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.picture = data.picture;
	}

	@Input() picture: Picture;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	uploadedFiles: any[] = [];
	pictureId: number;
	url: any;
	caption: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'pictureId': [],
		'title': [],
		'caption': [],
		'slPictureId': [],
		'url': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole picture object
		if (this.picture) {
			this.pictureId = this.picture.pictureId;
			this.url = this.picture.url;
			this.caption = this.picture.caption;
			this.fixDates();
			this.form1.patchValue(this.picture);
		}
	}
	
	getUploadUrl() { 
		return `${environment.apiUrl}/pictures/update-picture`; 
	}

	onBeforeUpload(event: any) {
		console.log("aaaaaaaa : "+JSON.stringify(event));
		event.formData.append('pictureId', this.picture.pictureId);
		this.isLoader = true;
	}
	
	onAfterUpload(event: any) {
		console.log("bbbbbbb : "+JSON.stringify(event));
		if(event.originalEvent.body.statusCode == 200){
			//this.url = event.originalEvent.url;
			this.doUpdate.emit(this.picture);
			this.messageService.add({ severity: 'success', summary: 'Success', detail: "Replace Image Successfully" });
		}
		this.isLoader = false;
	}
	
	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.pictureService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.picture = res.data.picture;
						this.doAdd.emit(this.picture);
					},
					(err: any) => {
						console.log('picture-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('picture: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.pictureService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.picture = res.data.picture;
						this.doUpdate.emit(this.picture);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.pictureService.removePicture(this.picture.pictureId)
				.subscribe(
					(res: any) => {
						console.log('picture-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.picture);
					},
					(err: any) => {
						console.log('picture-delete FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			pictureId: [this.pictureId],
			title: [],
			caption: [],
			slPictureId: [],
			createDate: [],
			fileName: [],
			describesType: [],
			virtualTourURL: [],
			amazonBucketName: [],
			sortOrder: [],
			lead: [],
			url: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.picture.pictureDate = moment(this.picture.pictureDate).toDate();
	}
}
